const rawMessages = arrayMessages.reduce((acc, obj) => {
  const [key, value] = Object.entries(obj)[0];
  acc[key] = value;
  return acc;
}, {});

const locales = [
  'ko',
  'en_US',
  'ja',
  'zh',
  'de',
  'es',
  'ru',
  'fr',
  'sv',
  'it',
  'hi',
  'vi',
  'id',
  'th',
  'pt',
  'tr',
  'pl',
  'ar',
  'ms',
  'nl',
  'zh_TW',
  'mn',
];
const transformedMessages = {};

for (const locale of locales) {
  transformedMessages[locale] = {};
  for (const key in rawMessages) {
    transformedMessages[locale][key] = rawMessages[key][locale];
  }
}

export default transformedMessages;

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import arrayMessages from './rawMessages';

export const useAllTranslations = () => {
  const { t } = useI18n();

  // Proxy로 모든 번역 키를 동적으로 매핑
  return new Proxy(
    {},
    {
      get(_, key) {
        return computed(() => t(key)); // 요청된 key를 자동으로 t(key)로 매핑
      },
    }
  );
};
